import { address } from '@solana/kit'
import { isAddress } from 'web3-validator'

import {
  NetworkValue,
  Networks,
  StableCoinValue,
  MAX_24_999_SELF_SERVE_AMOUNT,
  MAX_9999_SELF_SERVE_AMOUNT,
} from '@/utils/currencies'
import {
  TransactionType,
  TransactionValue,
} from '@/reducers/transactionReducer'
import type { Limits } from '@/utils/limits'

export function isValidWalletAddressForNetwork(
  walletAddress: string,
  network: NetworkValue
): boolean {
  if (!walletAddress) {
    return false
  }
  if (network === Networks.sol) {
    try {
      address(walletAddress)
      return true
    } catch {
      return false
    }
  }
  return isAddress(walletAddress)
}

export function resolveSelfServeMaxCad(
  limits: Limits | null,
  enable25kLimitIncrease: boolean
): number {
  if (limits) {
    return limits.leftSideCurrency.CAD.maximum
  }
  return enable25kLimitIncrease
    ? MAX_24_999_SELF_SERVE_AMOUNT
    : MAX_9999_SELF_SERVE_AMOUNT
}

export function resolveSelfServeMaxStableCoin(
  limits: Limits | null,
  stableCoin: StableCoinValue,
  enable25kLimitIncrease: boolean
): number {
  if (limits) {
    return limits.leftSideCurrency[stableCoin].maximum
  }
  return enable25kLimitIncrease
    ? MAX_24_999_SELF_SERVE_AMOUNT
    : MAX_9999_SELF_SERVE_AMOUNT
}

export function formatSelfServeMaxTooltipLabel(
  maxCad: number,
  locale: string
): string {
  const isFrench = locale.toLowerCase().startsWith('fr')
  const is25k = maxCad >= MAX_24_999_SELF_SERVE_AMOUNT

  if (isFrench) {
    return is25k ? '25 000 CAD' : '10 000 CAD'
  }
  return is25k ? '25k' : '10k'
}

export function requiresLargeOrderPaymentChoice({
  fiatAmount,
  transactionType,
  enableOtc,
  enable25kLimitIncrease,
  maxSelfServeCad,
}: {
  fiatAmount: number
  transactionType: TransactionValue
  enableOtc: boolean
  enable25kLimitIncrease: boolean
  maxSelfServeCad: number
}): boolean {
  return (
    enableOtc &&
    enable25kLimitIncrease &&
    transactionType === TransactionType.BUY &&
    fiatAmount > MAX_9999_SELF_SERVE_AMOUNT &&
    fiatAmount <= maxSelfServeCad
  )
}
